import { Link } from "react-router-dom";
import Header from "@/components/Header";
import MinimalFooter from "@/components/MinimalFooter";
import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Helmet>
        <title>Pagina non trovata | Fabbriche Toscane</title>
        <meta name="description" content="La pagina che stai cercando non esiste o è stata spostata." />
        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />
      </Helmet>
      <Header />
      <main className="flex-1 flex items-center justify-center">
        <div className="text-center px-6">
          <h1 className="font-display text-6xl md:text-8xl text-primary mb-4">404</h1>
          <p className="text-xl md:text-2xl text-foreground mb-2">Pagina non trovata</p>
          <p className="text-muted-foreground mb-8 max-w-md mx-auto">
            La pagina che stai cercando non esiste o è stata spostata.
          </p>
          <Button asChild><Link to="/">Torna alla Home</Link></Button>
        </div>
      </main>
      <MinimalFooter />
    </div>
  );
};

export default NotFound;
